export default PLATFORM => {
  return PLATFORM === 'mobile_iphone' || PLATFORM === 'mobile_iphone_messenger';
};
